import React from "react";

const PreventNDTFailuresSection =()=>{
    return(
        <>

      
      <section className=" bg-secondary position-relative  pb-2 pb-lg-5 mb-3">
       {/* <!-- Item --> */}
        <div className="container">
            <div className="row pb-5 mb-md-4 mb-lg-5 mt-5 pt-5 align-items-center justify-content-center">
              <div className="col-md-6 pb-1 mb-3 pb-md-0 mb-md-0 order-2 order-md-1 mt-5 mt-md-0 " data-jarallax-element="-25" data-disable-parallax-down="md">
                <img src="assets/services_img/infographic_img.png" className="d-block mx-auto" width="600" alt="grap"/>
              </div>
              <div className="col-md-6 pt-md-4 pt-lg-5 align-self-start order-1 order-md-2">
                    <div className="pe-md-4 me-md-2 ps-lg-5 ms-lg-5 ">
                    <p className="fs-lg fw-bold text-primary mb-2 pt-4">
                    Stop Reacting to NDT Failures. Start Preventing Them.                    </p>
                     
                    <p className="fs-lg text-white pb-2 pt-4 mb-0">
                    Expensive rework, project delays, and compliance headaches often stem from inspection, reporting, or compliance errors discovered too late.
                    </p>
                    <p className="fs-lg text-white pb-2 pt-4 mb-0">
                    Traditional oversight, when available, lacks the speed and consistency for true quality assurance—leaving projects exposed to significant risk.
                    </p>
                    <p className="fs-lg text-white pb-2 pt-4 mb-0">
                    Stop reacting to problems and start preventing them with verified, real-time data. Today’s projects demand immediate certainty to avoid costly surprises
                    </p>
                   

                    </div>
              </div>
            </div>
        </div>
      </section>

        </>
    )
}

export default PreventNDTFailuresSection